"use client";

import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/app/components/ui/form";
import { Textarea } from "@/app/components/ui/textarea";
import Icon from "../../Icon";
import { ContactFormData } from "../../../lib/forms/contact-schema";

type MessageSectionProps = {
  control: Control<ContactFormData>;
};

export function MessageSection({ control }: MessageSectionProps) {
  const { t } = useTranslation();
  const maxLength = 2000;

  return (
    <div className="space-y-4">
      <h3 className="text-base md:text-lg font-normal text-ui-card mb-4 flex items-center gap-2">
        <Icon name="envelope" size="md" className="text-ui-card/80" />
        {t("Message")}
      </h3>
      <FormField
        control={control}
        name="message"
        render={({ field }) => {
          const charCount = field.value?.length || 0;
          
          return (
            <FormItem>
              <div className="flex justify-between items-center mb-2">
                <FormLabel className="text-sm font-normal text-ui-card/90">
                  {t("Message")} <span className="text-red-500" aria-label={t("Required")}>*</span>
                </FormLabel>
                <span className={`text-xs font-light ${charCount > maxLength ? 'text-red-500' : 'text-ui-card/60'}`}>
                  {charCount}/{maxLength}
                </span>
              </div>
              <FormControl>
                <Textarea
                  {...field}
                  rows={8}
                  maxLength={maxLength}
                  placeholder={t("Write text here..")}
                  aria-required="true"
                  className="rounded-none border-ui-border bg-ui-page text-ui-card resize-none placeholder:text-ui-card/40 focus:ring-brand-accent focus:border-transparent"
                />
              </FormControl>
              <FormMessage className="text-xs text-red-600" />
            </FormItem>
          );
        }}
      />
    </div>
  );
}

